__webpack_require__.p = "/wp-content/mu-plugins/react-shortcode/react-app/";